import { IAsyncSelectOptionWithIcon } from 'interfaces/common'
import { IDocumentType } from 'interfaces/documentType'
import { ITag } from 'interfaces/tag'
import { ISearchFilterForm } from 'stores/searchStore'
import { getValidArray } from 'utils/common'

export function getDocumentTypeOptions(documentTypes: IDocumentType[]): IAsyncSelectOptionWithIcon<number>[] {
  return getValidArray(documentTypes).map(documentType => ({
    label: documentType?.name + ((documentType?.views ?? 0) > 1 ? ` | ${documentType?.views} views` : ''),
    value: documentType?.id,
    icon: documentType?.iconBuilder
  }))
}

export function getTagOptions(tags: ITag[]): IAsyncSelectOptionWithIcon<number>[] {
  return getValidArray(tags).map(tag => ({
    label: tag?.name,
    value: tag?.id
  }))
}

export function checkValidFilter(searchFilter: ISearchFilterForm): boolean {
  const { groups, tags, documentTypes, sort } = searchFilter
  return (
    sort !== '' ||
    getValidArray(tags)?.length > 0 ||
    getValidArray(groups)?.length > 0 ||
    getValidArray(documentTypes)?.length > 0
  )
}
